import React from 'react'
import {ServiciosBalconyItem} from './ServiciosBalconyItem'

function ServiciosBalcony(props) {
  const displayItems = (props) => {
    const servicios = props.servicios

    if (servicios.length > 0) {
      return servicios.map((servicio, index) => {
        return <ServiciosBalconyItem key={index} servicio={servicio} />
      })
    } else {
      return <h3>No hay servicios</h3>
    }
  }

  return <>{displayItems(props)}</>
}

export {ServiciosBalcony}
